import styled from '@emotion/styled';
import * as React from 'react';
import { MdxLink } from './MdxLink';

type InlineLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const InlineLink: React.FC<InlineLinkProps> = ({ children, ...props }) => (
  <S.Root data-inline-link-wrapper>
    <MdxLink {...props}>{children}</MdxLink>
  </S.Root>
);

namespace S {
  export const Root = styled.span`
    display: inline;
  `;
}
